import React, { useState, useContext } from "react";
import "../../styles/transaction.css";
import { FaCloudUploadAlt } from "react-icons/fa";
import "../../styles/contact/report.css";
import { AuthContext } from "../../context/AuthContext"; 
import { toast } from "react-toastify";

const Report = () => {
  const [files, setFiles] = useState([]);
  const [issue, setIssue] = useState("");
  const [loading, setLoading] = useState(false);

  const { reportBug } = useContext(AuthContext);

  const handleFileChange = (e) => {
    setFiles((prevFiles) => [...prevFiles, ...Array.from(e.target.files)]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if there is an issue and at least one file is uploaded
    if (!issue.trim() && files.length === 0) {
      toast.error("Please explain the issue and upload a file.");
      return;
    }

    if (!issue.trim()) {
      toast.error("Please explain the issue.");
      return;
    }

    if (files.length === 0) {
      toast.error("Please upload at least one file.");
      return;
    }

    try {
      setLoading(true);

      const res = await reportBug(issue, files);

      if (res?.success) {
        toast.success("Bug Report Submitted Successfully!");
        setIssue("");
        setFiles([]);
      } else {
        toast.error(res?.error || "Failed to submit report.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="report-container">
      <p className="report-subtext">
        Did you notice any abnormality while using the user web dashboard?
        Kindly submit a report here and we will fix it as soon as possible.
      </p>

      <form onSubmit={handleSubmit} className="report-form">
        <label className="upload-label">
          Upload Image/Screenshot (Optional)
        </label>

        <div className="upload-box">
          <FaCloudUploadAlt className="upload-icon" />
          <p>Upload file or drag and drop</p>
          <input
            type="file"
            multiple
            accept="image/png"
            onChange={handleFileChange}
          />
          <small>You can upload multiple files (png) up to 10MB</small>
        </div>

        {files.length > 0 && (
          <div className="uploaded-files">
            <p>Uploaded Files:</p>
            <ul>
              {files.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>
          </div>
        )}

        <label>Explain the issue</label>
        <textarea
          placeholder="Describe what happened..."
          value={issue}
          onChange={(e) => setIssue(e.target.value)}
        />

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Submitting..." : "Submit Report"}
        </button>
      </form>
    </div>
  );
};

export default Report;
